// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"306":"69aa748f","787":"e4eb0011"}[chunkId] + ".chunk.js";
};